export const successMessage = (n1, n2) => {
  if (n1 === 0 && n2 === 0) return null;
  if (n1 === n2) {
    return 'Todos os dados foram importados com sucesso!';
  }
  return `${n1} de ${n2} dados foram importados com sucesso!`;
};
